import { createContext, useContext } from "react";
import { HtmlLabel, Span } from "../../html";
import { isNil } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
export const FieldContext = /*#__PURE__*/createContext(null);
export function useFieldContext() {
  const context = useContext(FieldContext);

  if (!isNil(context)) {
    const {
      isGroup = false,
      ...rest
    } = context;
    const props = { ...rest,
      isGroup
    };
    return [props, true];
  }

  return [{}, false];
}
export function ClearFieldContext({
  children
}) {
  return /*#__PURE__*/_jsx(FieldContext.Provider, {
    value: null,
    children: children
  });
}
export function useFieldLabelProps({
  as: asProp
}) {
  const [{
    inputId,
    isGroup,
    labelClassName,
    labelId,
    required
  }, isInField] = useFieldContext();
  const as = isNil(asProp) ? isGroup ? Span : HtmlLabel : asProp;
  const props = isInField && {
    as,
    className: labelClassName,
    htmlFor: as === HtmlLabel ? inputId : undefined,
    id: labelId,
    required
  };
  return [props || {}, isInField];
}
export function useFieldInputProps() {
  const [{
    disabled,
    fluid,
    id,
    inputClassName,
    inputId,
    isGroup,
    labelId,
    messageId,
    required,
    validationState
  }, isInField] = useFieldContext();
  const props = isInField && {
    "aria-describedby": !isGroup ? !isNil(messageId) ? messageId : undefined : undefined,
    "aria-labelledby": !isGroup ? !isNil(labelId) ? labelId : undefined : undefined,
    className: inputClassName,
    disabled,
    fluid,
    id: !isGroup ? inputId : undefined,
    name: id,
    required,
    validationState
  };
  return [props || {}, isInField];
}
export function useFieldMessageProps() {
  const [{
    fluid,
    messageClassName,
    messageId,
    validationState
  }, isInField] = useFieldContext();
  const props = isInField && {
    "aria-live": "polite",
    className: messageClassName,
    fluid,
    id: messageId,
    validationState
  };
  return [props || {}, isInField];
}